import React, { useContext, useState } from 'react';

import Input from 'components/shared/FormAdapters/FormDefault/Input';
import Icon from 'components/shared/Icon';
import EnterIcon from 'components/shared/Icon/icons/EnterIcon';
import Text from 'components/shared/Typography/Text';
import { ENTER_VIDEO_HOST_LINK, PLEASE_ENTER_VIDEO_HOST_LINK } from 'constants/texts';
import { isValidVideoUrl } from 'utils/parseVideoUrl';

import LandingPageContext from '../../../contexts/LandingPageContext';
import { IVideoProps } from '../types';
import styles from './index.module.css';

function VideoInput({ onUpdate, data }: IVideoProps) {
  const [isError, setIsError] = useState(false);
  const { readOnly } = useContext(LandingPageContext);

  const addLinkVideo = (value: string) => {
    const newObject = {
      ...data,
      data: {
        source: value,
      },
    };
    if (!isValidVideoUrl(value)) {
      return setIsError(true);
    }
    setIsError(false);

    if (onUpdate) {
      return onUpdate(newObject);
    }
  };

  return (
    <div className={styles.wrapper}>
      <Input
        autoFocus
        placeholder={ENTER_VIDEO_HOST_LINK}
        className={styles.input}
        onKeyPress={(e: KeyboardEvent) => {
          if (e.charCode === 13) {
            // @ts-ignore
            addLinkVideo(e.target?.value);

            e.preventDefault();
          }
        }}
        onBlur={(e) => addLinkVideo(e.target.value)}
        readOnly={readOnly}
      />

      <div className={styles.placeholder}>
        <Text accent type="gray" size="small">
          Press Enter to Add
        </Text>
        <Icon component={EnterIcon} width="12px" height="12px" className={styles.icon} />
      </div>

      {!readOnly && isError && (
        <Text accent type="danger" size="small">
          {PLEASE_ENTER_VIDEO_HOST_LINK}
        </Text>
      )}
    </div>
  );
}

export default VideoInput;
